import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Form } from 'core/forms';
import i18n from 'i18next';
import pick from 'lodash/pick';
import { useModals } from 'core/notifications';

import { Typo } from 'uikit/content';

import getAxiosConfig from '../helpers/getAxiosConfig';

import axios from '@/util/axios';
import { addErrorsToFormState, NewItemFormButtons } from '@/exceed';

import styles from '../styles/newLiveVideoForm.module.scss';

const NewLiveVideoForm = ({ id, schema: { agenda_item: agendaItemSchema, ...schema } }) => {
  const [agendaItemFormState, setAgendaItemFormState] = useState({});
  const [formState, setFormState] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { getModel, removeModal, setModel } = useModals();
  const model = getModel(id);

  const handleCancel = () => {
    removeModal();
  };

  const handleBackendErrors = (error) => {
    const prevModel = model;
    const fieldProcessor = (source) => {
      const agendaItemRoot = 'agenda_item.';
      return source.includes(agendaItemRoot)
        ? agendaItemFormState[source.split(agendaItemRoot).pop()]
        : formState[source.split('data.').pop()];
    }
    addErrorsToFormState({ formState, fieldProcessor, error })
    setModel(id, { agenda_item: {} });
    setModel(id, prevModel);
  };

  const handleAgendaItemLoad = (state) => {
    setAgendaItemFormState(state.formState);
  };

  const handleAgendaItemUpdate = (state) => {
    setAgendaItemFormState(state.formState);
    setModel(id, { ...model, agenda_item: { ...model.agenda_item, ...state.update } });
  };

  const handleLoad = (state) => {
    setFormState(state.formState);
  };

  const handleSubmit = async () => {
    setIsSubmitting(true);

    try {
      removeModal({
        payload: (await axios(getAxiosConfig('create-live-video', model))).data.data,
        type: 'submit',
      });
    } catch (error) {
      setIsSubmitting(false);
      handleBackendErrors(error);
    }
  };

  const handleUpdate = (state) => {
    setFormState(state.formState);
    setModel(id, { ...model, ...state.update });
  };

  const hasFormError =
    Object.values(formState).some(({ hasError }) => hasError) ||
    Object.values(agendaItemFormState).some(({ hasError }) => hasError);

  return (
    <>
      <Typo className={styles.title} element="h2" variant="d01">
        {i18n.t('general')}
      </Typo>
      <div className={styles.form}>
        <Form
          model={pick(model, Object.keys(schema))}
          onLoad={handleLoad}
          onUpdate={handleUpdate}
          schema={schema}
        />
      </div>
      <Typo className={styles.title} element="h2" variant="d01">
        {i18n.t('create-your-first-agenda-item')}
      </Typo>
      <div className={styles.form}>
        <Form
          model={model.agenda_item}
          onLoad={handleAgendaItemLoad}
          onUpdate={handleAgendaItemUpdate}
          schema={agendaItemSchema}
        />
      </div>
      <NewItemFormButtons
        hasError={hasFormError}
        isFullScreen
        isSubmitting={isSubmitting}
        onCancel={handleCancel}
        onSubmit={handleSubmit}
        submitText={i18n.t('create')}
      />
    </>
  );
};

NewLiveVideoForm.propTypes = {
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  schema: PropTypes.shape({}).isRequired,
};

export default NewLiveVideoForm;
